import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'


const _hoisted_1 = { class: "px-6 overflow-hidden font-montserrat" }
const _hoisted_2 = { class: "flex text-xs gap-x-2 items-center" }
const _hoisted_3 = { class: "font-bold  text-black" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-[6px] h-[6px] rounded-full bg-gray-lp-1300" }, null, -1)
const _hoisted_5 = { class: "font-normal  text-gray-lp-800" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "w-full border-t border-gray-lp-200" }, null, -1)
const _hoisted_7 = { class: "flex flex-row justify-between" }
const _hoisted_8 = { class: "flex flex-row gap-x-1 items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "check"
}, null, -1)
const _hoisted_10 = { class: "font-semibold text-green-lp-1500" }
const _hoisted_11 = { class: "font-normal text-gray-lp-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      class: "pt-1 mb-4",
      label: _ctx.$t('userManagement.detail.deviceInfo')
    }, null, 8, ["label"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (device, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "rounded-lg border border-gray-lp-1400 px-3 py-2 flex flex-col gap-y-2 mt-2"
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.mapDeviceName(device)), 1),
          _hoisted_4,
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.formatDateToString(device.lastActiveAt)), 1)
        ]),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('userManagement.detail.confirmed')) + " " + _toDisplayString(device.approvedBy), 1)
          ]),
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDateToString(device.approvedAt)), 1)
        ])
      ]))
    }), 128))
  ]))
}